<template>
  <BallLogo
    v-if="!isLoaded"
    class="App__logo"
  />
  <RouterView v-else />
  <Analytics />
</template>

<script lang="ts" setup>
import BallLogo from "@/components/BallLogo.vue";
import useAppLinks from "@/composables/useAppLinks";
import useOneSignal from "@/composables/useOneSignal";
import useVersionCheck from "@/composables/useVersionCheck";
import { RouteName } from "@/lib/router/routes";
import detectOS from "@/lib/utils/platform/detectOS";
import isNative from "@/lib/utils/platform/isNative";
import useAuthStore from "@/stores/useAuthStore";
import { SplashScreen } from "@capacitor/splash-screen";
import { useSeoMeta } from "@unhead/vue";
import { Analytics } from "@vercel/analytics/vue";
import { storeToRefs } from "pinia";
import { onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const authStore = useAuthStore();
const {
  isSignedIn,
} = storeToRefs(authStore);
const {
  subscribeToAuthChanges,
} = authStore;
const isLoaded = ref(false);

useSeoMeta({
  titleTemplate: (title) => {
    return title ? `${title} | Ball.app` : "Ball.app - Because ball is life";
  },
});

if (isNative) {
  useAppLinks();
  useOneSignal();
  useVersionCheck();
}

onMounted(() => {
  document.documentElement.dataset.os = detectOS();
});

subscribeToAuthChanges().then(() => {
  isLoaded.value = true;

  if (isNative) SplashScreen.hide();
});

watch(isSignedIn, () => {
  if (!isSignedIn.value) {
    router.push({
      name: RouteName.login,
    });
  }
});
</script>

<style lang="scss" scoped>
.App__logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
